module.exports = __webpack_public_path__ + "static/img/2.030e2ae.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/4/2/eng/2.png
// module id = McPG
// module chunks = 0